export const siteMeta = {
  brand: "日本伦理剧",
  tagline: "NHON RINRI GEKI",
  slogan: "认真对待每一部关于「该不该」的故事",
  email: "editorial@nihonrinri-demo.jp",
  description:
    "专注于提供丰富的日本伦理题材电视剧和影视内容，涵盖多种剧情类型，帮助用户了解和观看相关作品，体验独特的文化故事。",
  disclaimer:
    "本站所有剧名、人物、评分、制作公司与专题内容均为虚构演示数据，仅用于界面演示，不对应任何真实影视作品，亦不提供播放与下载服务。",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "分类", to: "/category/ethics-drama" },
  { label: "专题", to: "/special/family-web" },
  { label: "搜索", to: "/search" },
  { label: "关于", to: "/about" },
];